import api from '../../api/index';

const features = `${process.env.VUE_APP_BASE_URI}/enterprise/features`;

const getDefaultState = () => {
  return {
    features: {},
    popup: false,
    seen: false,
    lastPageData: {},
  };
};

const state = getDefaultState();

const getters = {
  features: (state) => state.features,
  popup: (state) => state.popup,
  seen: (state) => state.seen,
  lastPageData: (state) => state.lastPageData,
};

const actions = {
  async getFeatures({ commit }) {
    commit('getFeatures_request');
    const res = await api.get(features);
    if (res.data.status === 'success') {
      commit('getFeatures_success', res.data.data);
    }
    return res;
  },
  async updateFeature({ commit }, data) {
    commit('updatefeature_request');
    const res = await api.post(features, data);
    if (res.data.status === 'success') {
      commit('updatefeature_success', res.data.message);
    }
    return res;
  },

  async openPopUp({ commit }) {
    commit('open_popup');
    return;
  },
  async seenPopUp({ commit }) {
    commit('seen_popup');
    return;
  },
  async updatePageNumber({ commit }, lastPageNumber) {
    commit('update_pagenumber', lastPageNumber);
    return;
  },
};

const mutations = {
  getFeatures_request: (state) => (state.status = 'loading'),
  getFeatures_success: (state, data) => {
    state.status = 'success';
    state.features = data;
  },
  updatefeature_request: (state) => (state.status = 'loading'),
  updatefeature_success: (state) => {
    state.status = 'success';
  },
  open_popup: (state) => {
    state.popup = !state.popup;
  },
  seen_popup: (state) => {
    state.seen = !state.seen;
  },
  update_pagenumber: (state, lastPageData) => {
    state.lastPageData = lastPageData;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
